import $ from "jquery";
import Q from 'q';

import TraceKit from 'rgs-tracekit';

const withGuards = callback => {
	TraceKit.notifications = true;

	return Q.Promise($)
		.then(() => callback && callback())
		.catch(e => {
			console.error(e);
			throw e;
		})
		.done();
};


const withDOMGuard = callback => {
	return Q.Promise($)
		.then(() => callback && callback())
		.done();
};

export {
	withGuards,
	withDOMGuard,
};
